var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHazmat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90411 7.36221C5.90411 7.45737 5.93039 7.55528 5.93477 7.65539V7.77475C5.93476 8.44703 5.67682 9.09344 5.21457 9.57955C4.75233 10.0657 4.12137 10.3541 3.45289 10.3848H3.33408M0.733398 7.772C0.733428 7.27868 0.872477 6.79544 1.13446 6.37819C1.39644 5.96095 1.77066 5.62674 2.21381 5.41423C2.65696 5.20173 3.15094 5.11961 3.63861 5.17737C4.12627 5.23514 4.5877 5.43043 4.9695 5.74065M8.53545 10.3848C8.15905 10.3848 7.78713 10.3027 7.44539 10.1442C7.10364 9.9857 6.80022 9.75457 6.55606 9.46677C6.31191 9.17896 6.13285 8.84134 6.03126 8.47723C5.92966 8.11311 5.90795 7.73118 5.96762 7.35781H5.93477M6.90058 5.73845C7.27457 5.43475 7.72506 5.24117 8.20198 5.17922C8.67891 5.11728 9.16359 5.1894 9.60216 5.38756C10.0407 5.58573 10.416 5.90218 10.6864 6.30175C10.9567 6.70133 11.1114 7.16837 11.1334 7.65099V7.77035M5.004 5.67299C4.609 5.52145 4.25674 5.27544 3.97773 4.95628C3.69871 4.63711 3.50137 4.25442 3.40278 3.84135C3.3042 3.42827 3.30735 2.99728 3.41196 2.58571C3.51657 2.17413 3.7195 1.79439 4.00314 1.47938L4.09294 1.38477M7.77112 1.38477C8.0781 1.69297 8.30342 2.07345 8.42656 2.49154C8.5497 2.90963 8.56673 3.35203 8.47611 3.77843C8.38549 4.20482 8.19009 4.60166 7.90773 4.93276C7.62537 5.26387 7.26502 5.51872 6.85952 5.67409",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazmat);
export default __webpack_public_path__ + "static/media/hazmat.011352dc800eceff12a75817fa2886e0.svg";
export { ForwardRef as ReactComponent };